<template>
  <div class="teamExam"  :class="SCREEN.mobile ? 'screen-teamExam' : ''">
      <div v-if="activeBox == 1" class="teamExamEnter">
          <div class="enterBox">
            <div class="enterTitle">
              企业客户预约入口
            </div>
            <div class="itemName">就诊人</div>
            <a-select v-model="activeHisPatientId" class="personSelect" @change="consultantPeopleChange">
              <a-select-option v-model="item.hisId" v-for="(item, index) in consultantPeopleList" :key="item.id + index">
                {{item.name}}
              </a-select-option>
            </a-select>
            <div class="itemName">证件号</div>
            <a-input v-model="idNo" class="idInput" disabled></a-input>
            <a-button type="primary" class="submitButton" @click="submit()">
              提交
            </a-button>
            <div class="tips">输入公司或团队为您提供的体检编号、即可预约体检时间</div>
          </div>
      </div>
      <div v-if="activeBox == 2" class="teamExamInfo">
        <div class="m-main">
          <div class="teamExamInfoTitle">
            团检预约
          </div>
          <div class="teamExamInfoBox">
            <div class="teamExamSubTitle">
              <i></i>
              <p>团体体检套餐</p>
            </div>
            <div class="teamExamList">
              <div class="teamExamListItem" v-for="(item, index) in teamExamList" :key="index">
                <div class="teamExamListItemLeft">
                  <img src="../images/itemIcon.png"  />
                </div>
                <div class="teamExamListItemRight">
                  <div class="teamExamItemTitle">{{item.packageName}}</div>
                  <div class="companyName">{{item.companyName}}</div>
                  <div class="teamExamItemRow">
                    <div class="teamExamItemRowLeft">体检时间：{{item.reserveTime}}</div>
                    <div class="teamExamItemRowRight" @click="chooseDate(index)">选择 》</div>
                  </div>
                  <div class="teamExamItemRow">
                    <div class="teamExamItemRowLeft">套餐详情</div>
                    <div class="teamExamItemRowRight" @click="viewDetail(item.packageCode)">查看 》</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="teamExamSubTitle">
              <i></i>
              <p>体检人信息</p>
            </div>
            <div class="personInfo">
              <div class="personInfoRow">
                <div class="personInfoRowLeft">姓名</div>
                <div class="personInfoRowRight">{{activePerson.name}}</div>
              </div>
              <div class="personInfoRow">
                <div class="personInfoRowLeft">证件号</div>
                <div class="personInfoRowRight">{{activePerson.idNo}}</div>
              </div>
              <div class="personInfoRow">
                <div class="personInfoRowLeft">手机号</div>
                <div class="personInfoRowRight">{{activePerson.phone}}</div>
              </div>
            </div>
            <div class="authLine">
              <a-checkbox class="checkBoxContent" v-model="checkValue" @change="checkBoxChange(value)">
                我已阅读并同意
              </a-checkbox>
              <p class="agreement" @click="viewAgreement()">《用户授权协议》</p>
            </div>
            <div class="submitLine">
              <a-button type="primary" class="submitButtonTwo" @click="submitTwo()">
                提交
              </a-button>
            </div>
          </div>
        </div>  
      </div>
      <div v-if="activeBox == 3" class="teamExamDetail">
        <div class="m-main">
          <div class="teamExamInfoTitle">
            套餐详情
          </div>
          <div class="teamExamDetailInfoBox">
            <div class="teamExamDetailInfoBoxLeft">
              <img v-if="medicalExamDetail.packageSex==1" src="../images/man.png" />
              <img v-if="medicalExamDetail.packageSex==2" src="../images/woman.png" />
              <img v-if="medicalExamDetail.packageSex==3" src="../images/general.png" />
            </div>
            <div class="teamExamDetailInfoBoxRight">
              <div class="detailInfoTitle">{{medicalExamDetail.packageName}}</div>
              <div class="detailInfoFee">¥{{medicalExamDetail.packagePrice}}</div>
              <div class="detailInfoSex">试用性别：
                <span v-if="medicalExamDetail.packageSex==1">男</span>
                <span v-if="medicalExamDetail.packageSex==2">女</span>
                <span v-if="medicalExamDetail.packageSex==3">通用</span>
              </div>
            </div>
          </div>
          <div class="teamExamInfoTab">
            <a-tabs default-active-key="1">
              <a-tab-pane key="1" tab="套餐项目">
                <div>
                  <!-- <div >
                    <div>第一类  临床检查</div>
                    <table>
                      <tr>
                        <th>项目</th>
                        <th>具体内容</th>
                        <th>临床意义</th>
                      </tr>
                      <tr>
                        <th>一般检查</th>
                        <th>身高,体重,体重指数BMI,血压,脉搏,腰围，臀围，腰臀比</th>
                        <th>身高,体重,体重指数BMI,血压,脉搏,腰围，臀围，腰臀比</th>
                      </tr>
                      <tr>
                        <th>外科检查</th>
                        <th>皮肤，浅表淋巴结，甲状腺，乳房，脊柱，四肢关节，肛门指诊，泌尿生殖系统</th>
                        <th>皮肤，浅表淋巴结，甲状腺，乳房，脊柱，四肢关节，肛门指诊，泌尿生殖系统</th>
                      </tr>
                    </table>
                  </div> -->
                  <div class="mobileTable" v-if="SCREEN.mobile">
                    <div
                      class="tableData"
                      v-for="(item, index) in medicalExamDetailData"
                      :key="index"
                    >
                      <div class="item">
                        <div class="left">项目：</div>
                        <div class="right">{{ item.itemName }}</div>
                      </div>
                      <div class="item">
                        <div class="left">具体内容：</div>
                        <div class="right">{{ item.itemContent }}</div>
                      </div>
                      <div class="item">
                        <div class="left">临床意义：</div>
                        <div class="right">{{ item.itemMean }}</div>
                      </div>
                    </div>
                  </div>
                  <div v-else class="tablebox">
                    <a-table
                      :columns="columns2"
                      :data-source="medicalExamDetailData"
                      :pagination="false"
                    >
                    </a-table>
                  </div>
                </div>
              </a-tab-pane>
              <a-tab-pane key="2" tab="体检须知" force-render>
                <div>
                  <div class="teamExamSubTitle">
                    <i></i>
                    <p>团体体检套餐</p>
                  </div>
                  <div class="examTipsArea">
                    <div>1.  为了保证体检质量，请您检前三天清酒，体检前-晚十点钟之后禁食禁水，早些休息，体检当天空腹，带上身份证前来体检；</div>
                    <div>2.  体检当日穿宽松衣物，尽量不带首饰便于查体避开月经期；</div>
                    <div>3.  有高血压病史允许喝一口白水吃药，胰岛素及降糖药物当日晨起暂停；</div>
                    <div>4.  半年内有备孕计划者；</div>
                    <div>5.  老年特特殊人群需要家属陪同。</div>
                  </div>
                  <div class="teamExamSubTitle">
                    <i></i>
                    <p>体检地点</p>
                  </div>
                  <div class="examTipsArea">
                    江苏省苏州市吴江经济技术开发区庞东路600号
                  </div>
                  <div class="teamExamSubTitle">
                    <i></i>
                    <p>体检时间</p>
                  </div>
                  <div class="examTipsArea">每周二至周日8:00-12:00，请于10:00之 前到达体检节假日及周一休息)，因个人原因不能按时体检的，请排前1天拨打
                      <span class="examPhone">0551-66981698</span>
                      电话联系我们调整体检时间
                  </div>
                </div>
              </a-tab-pane>
            </a-tabs>
          </div>
          <div class="submitLine">
            <a-button type="primary" class="submitButtonTwo" @click="goBackExamInfo()">
              返回
            </a-button>
          </div>
        </div>
      </div>
      <div v-if="activeBox == 4" class="success">
        <div class="m-main">
          <div class="successBox">
            <div class="successTitleBox">
              <div class="successTitle">预约成功!</div>
              <div class="successTips">请合理安排时间，提前到院检查。</div>
              <div class="successDate">{{successTeamExamData[0].createTime}}</div>
            </div>
            <div class="successContentBox">
              <div class="contentBox">
                <div class="contentRow">
                  <div class="contentRowLeft">体检人</div>
                  <div class="contentRowRight">{{activePerson.name}}</div>
                </div>
                <div class="contentRow">
                  <div class="contentRowLeft">证件号</div>
                  <div class="contentRowRight">{{activePerson.idNo}}</div>
                </div>
                <div class="contentRow">
                  <div class="contentRowLeft">手机号</div>
                  <div class="contentRowRight">{{activePerson.phone}}</div>
                </div>
                <div class="contentRow">
                  <div class="contentRowLeft">体检类型</div>
                  <div class="contentRowRight">团检</div>
                </div>
              </div>
              <div class="contentBox" v-for="(item, index) in successTeamExamData" :key="index">
                <div class="contentRow">
                  <div class="contentRowLeft">体检套餐</div>
                  <div class="contentRowRight">{{item.packageName}}</div>
                </div>
                <div class="contentRow">
                  <div class="contentRowLeft">预约日期</div>
                  <div class="contentRowRight">{{item.reserveDate}}</div>
                </div>
                <div class="contentRow">
                  <div class="contentRowLeft">预约编号</div>
                  <div class="contentRowRight">{{item.reserveId}}</div>
                </div>
                <div class="contentRow">
                  <div class="contentRowLeft">企业信息</div>
                  <div class="contentRowRight">{{item.companyName}}</div>
                </div>
              </div>
            </div>
            <div class="submitLine">
              <a-button type="primary" class="submitButtonTwo" @click="goBackEnter()">
                返回
              </a-button>
            </div>
          </div>
        </div>
      </div>

      <a-modal v-model="chooseDateVisible" title="就诊日期选择" @ok="handleDateOk" @cancel="handleDateCancel">
        <!-- <a-date-picker
        v-model="reserveDateSelect"
        format="YYYY-MM-DD"
        :disabled-date="disabledDate"
        @change="onDateChange" /> -->
        <a-select v-model="reserveDateSelect" class="personSelect" @change="onDateChange">
          <a-select-option 
          v-model="item.date" 
          v-for="(item, index) in dutyDateList" 
          :key="index" 
          :disabled="item.dateFlag == 1">
            {{item.date}}
          </a-select-option>
        </a-select>
      </a-modal>
      <a-modal v-model="authVisible" title="用户授权协议">
        <div>尊敬的京东方医院用户：</div>
        <div>为了让京东方医院更好的提供体检及报告查询务，请您仔细阅读并确认以下服务说明:</div>
        <div>1.  开通个人体检报告查询功能须征得您本人(预约人的授权。</div>
        <div>2.  “京东方医院”与各体检机构及医院实现体检数据对接，体检的套餐项目信息、排期信息、预约信息及体检报告数据将通过加密方式实时与体检机构/医院完成信息核实与传递，如经体检机构/医方的接口返回您已经完成了体检并出具了电子格式的体检报告，您即可通过我平台或所约机构的官方网站报告查询入口查阅您的体检报告。</div>
        <div>3.  当您签署本协议时，即表明您同意为您提供体检服务的机构及医院向本平台提供您的体检报告，并同意免于追究体检机构及医院提供体检报告的一切责任。</div>
        <div>4.  为了您历年的体检报告信息的完整性，我们会将您查询后的体检报告(含原始数据，但不包括乙肝检查结果等国家法律法规不允许公开的数据)加密后进行存档，便于您本人随时查看;为了更好地为您提供服务，您的体检报告结果可能会提供给与我们合作的第三方机构，但我们会自动去掉和您个人有关的隐私信息(如姓名、身份证号码、电话、地址等)，。</div>
        <div>5.  在信息安全方面，我们保证用户信息存储在具有专业安全资质的机房;</div>
      </a-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from 'moment';
import config from "./config.js";

export default {
  name: "hospital-team-exam-001",
  data() {
    return Object.assign(
      {
        hospitalCode: 'H06',
        activeBox: 1,
        activeHisPatientId: '',
        consultantPeopleList: [],
        dutyDateList: [],
        name: '',
        idNo: '',
        idType: '',
        activePerson: {},

        teamExamList: [],
        teamExamItem: {},
        teamExamItemIndex: null,

        chooseDateVisible: false,
        authVisible: false,
        checkValue: false,

        reserveDate: '',
        reserveDateSelect: '',

        columns2: [
          {
            title: "项目",
            dataIndex: "itemName",
            key: "itemName",
            width: 150
          },
          {
            title: "具体内容",
            dataIndex: "itemContent",
            key: "itemContent"
          },
          {
            title: "临床意义",
            dataIndex: "itemMean",
            key: "itemMean"
          },
        ],
        medicalExamDetail: {},
        medicalExamDetailData: [],

        successTeamExamData: [],
      },
      config
    );
  },

  mounted(){
    this.getConsultantList();
    this.getExamDutyDate();
  },
  computed: mapGetters({
    SCREEN: "getScreen"
  }),
  methods: {
    // 获取就诊人列表
    getConsultantList() {
      // 测试假数据
      // this.consultantPeopleList= [
      //     {
      //       id: 1111,
      //       hospitalCode: "H06",
      //       userId: 60023276593,
      //       name: "主就诊人",
      //       phone: "15321656338",
      //       idNo: "110103199103032033",
      //       relation: "0",
      //       cardType: "01",
      //       cardNo: "0000116375",
      //       hisId: "0000000291",
      //       gender: "1",
      //       createTime: "2021-09-18 14:31:28",
      //       idType: "01",
      //       birthday: "1991-03-03",
      //       relationshipCode: "0"
      //     },
      //     {
      //       id: 1112,
      //       hospitalCode: "H06",
      //       userId: 60023276593,
      //       name: "就诊人2",
      //       phone: "13667186392",
      //       idNo: "110106200609097223",
      //       relation: "4",
      //       cardType: "01",
      //       cardNo: "0000116416",
      //       hisId: "0000000063",
      //       gender: "2",
      //       createTime: "2021-09-22 14:29:08",
      //       idType: "01",
      //       birthday: "2006-09-09",
      //       relationshipCode: "4"
      //     },
      //     {
      //       id: 1115,
      //       hospitalCode: "H06",
      //       userId: 60023276593,
      //       name: "就诊人5",
      //       phone: "13011111989",
      //       idNo: "110106201506066666",
      //       relation: "1",
      //       cardType: "01",
      //       cardNo: "0000116420",
      //       hisId: "0000000302",
      //       gender: "2",
      //       createTime: "2021-09-22 18:03:56",
      //       idType: "01",
      //       birthday: "2015-06-06",
      //       relationshipCode: "1"
      //     }
      //   ];

      //   console.log("getConsultantList:", this.consultantPeopleList);


      let ut = localStorage.getItem('ut');
      // localStorage中没有ut，判断是否登录
      if(ut == undefined || ut == null || ut == ""){
        this.$router.push({
          path: "/personalCenter/login",
          query: {redirect: '/medicalCenter/teamExam'} // 将跳转的路由path作为参数，登录成功后跳转到该路由
        })
        return
      }
      let data = {hospitalCode:	this.hospitalCode};
      this.$API.getPatientList(data).then(res => {
        if(res.code == 0) {
          this.consultantPeopleList = res.data || [];
          if(this.consultantPeopleList.length > 0) {
            this.activeHisPatientId = this.consultantPeopleList[0].hisId;
            this.activePerson = this.consultantPeopleList[0];
            this.name = this.consultantPeopleList[0].name;
            this.idNo = this.consultantPeopleList[0].idNo;
            this.idType = this.consultantPeopleList[0].idType;
          }else {
            this.activeHisPatientId = 0;
          }
        }else {
          this.$message.error(res.msg);
        }
      });
    },

    consultantPeopleChange(value){
      for(let i=0; i<this.consultantPeopleList.length; i++){
        if(this.consultantPeopleList[i].hisId==value){
          this.activePerson = this.consultantPeopleList[i];
        }
      }
      this.name = this.activePerson.name;
      this.idNo = this.activePerson.idNo;
      this.idType = this.activePerson.idType;

      console.log("consultantPeopleChange:", this.activePerson)
    },

    submit(){
      let data = {
        idType: this.idType,
        idNo: this.idNo,
        patientName: this.name
      }
      this.$API.getBookDetail(data).then(res => {
        if(res.code == 0) {
          this.teamExamList = res.data;
          this.teamExamList.forEach(item=>{
            item.reserveTime = ''
          })
          this.activeBox = 2;
        }
      })

      // 测试假数据
      // this.teamExamList = [
      //   {
      //     reserveId: '202109010154',
      //     packageCode: '000179',
      //     companyName: '吴江开发区管委会',
      //     packageId: '000179',
      //     reservationNumber: '202109010154',
      //     packageName: '21开发区管委会-男',
      //     medicalExamType: '1',
      //     hisPatientName: '金海民',
      //     isChange: '0',
      //   },
      //   {
      //     reserveId: '202109010166',
      //     packageCode: '000178',
      //     companyName: '吴江开发区管委会',
      //     packageId: '000178',
      //     reservationNumber: '202109010154',
      //     packageName: '10开发区管委会-男',
      //     medicalExamType: '1',
      //     hisPatientName: '金海民',
      //     isChange: '0',
      //   }
      // ]
      
      // this.teamExamList.forEach(item=>{
      //   item.reserveTime = ''
      // })
      // this.activeBox = 2;
    },

    submitTwo(){
      let reserveTimeFlag = true;
      let data = [];
      console.log("teamExamList data:",this.teamExamList)
      for(let i=0; i<this.teamExamList.length; i++){
        if(this.teamExamList[i].reserveTime == ''){
          reserveTimeFlag = false;
          console.log("teamExamList data i:",i)
          break;
        }else{
          let item = {};
          item.reserveId = this.teamExamList[i].reserveId;
          item.reserveDate = this.teamExamList[i].reserveTime;
          item.idNo = this.idNo;
          item.packageCode = this.teamExamList[i].packageCode;
          item.packageName = this.teamExamList[i].packageName;
          item.phone = this.activePerson.phone;
          data.push(item)
        }
      }
      if(reserveTimeFlag == false){
        this.$message.warning('请为套餐选择时间');
        return;
      }
      console.log("reserveTimeFlag:",reserveTimeFlag)
      console.log("submit data:",data)
      if(this.checkValue == false){
        this.$message.warning('请阅读用户协议并勾选');
        return;
      }
      
      this.$API.modifyExamGroupInfo(data).then(res => {
        if(res.code == 0) {
          this.successTeamExamData = res.data;
          this.checkValue = false;
          this.activeBox = 4;
        }
      })
      
      // 测试假数据
      // this.successTeamExamData = [
      //   {
      //     reserveId: '2021093011121',
      //     reserveDate: '2021-10-05',
      //     type: 'G',
      //     createTime: '2021-09-30 12:11:11',
      //     companyName: '吴江开发区管委会',	
      //     patientName: '主就诊人',
      //     packageCode: '000178',
      //     packageName: '10开发区管委会-男',
      //   },
      //   {
      //     reserveId: '2021093011121',
      //     reserveDate: '2021-10-06',
      //     type: 'G',
      //     createTime: '2021-09-30',
      //     companyName: '吴江开发区管委会',	
      //     patientName: '主就诊人',
      //     packageCode: '000179',
      //     packageName: '20开发区管委会-男',
      //   }
      // ]
      // this.checkValue = false;
      // this.activeBox = 4;
    },

    // 获取可选日期
    getExamDutyDate(){
      let data = {
        hospitalCode:this.hospitalCode
      }
      this.$API.getExamDutyDate(data).then(res => {
        if(res.code == 0) {
          this.dutyDateList =  res.data;
        }
      })

      // 测试假数据
      // this.dutyDateList = [
      //   {
      //       date: "2021-09-29",
      //       dateFlag: 0,
      //       week: "星期三"
      //   },
      //   {
      //       date: "2021-09-30",
      //       dateFlag: 0,
      //       week: "星期四"
      //   },
      //   {
      //       date: "2021-10-01",
      //       dateFlag: 0,
      //       week: "星期五"
      //   },
      //   {
      //       date: "2021-10-02",
      //       dateFlag: 1,
      //       week: "星期六"
      //   },
      //   {
      //       date: "2021-10-03",
      //       dateFlag: 1,
      //       week: "星期日"
      //   },
      //   {
      //       date: "2021-10-04",
      //       dateFlag: 0,
      //       week: "星期一"
      //   },
      //   {
      //       date: "2021-10-05",
      //       dateFlag: 0,
      //       week: "星期二"
      //   },
      //   {
      //       date: "2021-10-06",
      //       dateFlag: 0,
      //       week: "星期三"
      //   },
      //   {
      //       date: "2021-10-07",
      //       dateFlag: 0,
      //       week: "星期四"
      //   },
      //   {
      //       date: "2021-10-08",
      //       dateFlag: 0,
      //       week: "星期五"
      //   }
      // ]
    },
    disabledDate(current) {
      // Can not select days before today and today
      let firstDate = this.dutyDateList[0].date;
      let lastDate = this.dutyDateList[this.dutyDateList.length-1].date;
      console.log("current:",current)
      console.log("firstDate:",firstDate)
      console.log("lastDate:",lastDate)
      let result = current && current < moment(firstDate).subtract(1, "days") || current > moment(lastDate).subtract(1, "days") || (current == moment("2021-10-04").endOf('day'));
      for(let i=0; i<this.dutyDateList.length; i++){
        if(this.dutyDateList[i].dateFlag == 1){
          // result = result || current == moment(this.dutyDateList[i].date).endOf('day')
        }
      }
      // return current && current < moment().endOf('day');
      console.log("disabledDate:", current && current < moment(firstDate).endOf('day') || current > moment(lastDate).endOf('day'))
      console.log("result:", result)
      // return current && current < moment('2021-10-05').endOf('day');
      return current && current < moment(firstDate).endOf('day') || current > moment(lastDate).endOf('day');
      // return result;
      // return current && current == moment('2021-10-05').endOf('day');
    },
    // 选择日期弹框
    chooseDate(index){
      this.teamExamItemIndex = index;
      this.chooseDateVisible = true;
    },

    handleDateOk(){
      this.reserveDateSelect = '';
      this.chooseDateVisible = false;
    },
    handleDateCancel(){
      this.reserveDateSelect = '';
      console.log("handleDateCancel:", this.reserveDateSelect)
    },

    onDateChange(value){
      console.log("date value:", value)
      console.log("date value 1:", this.reserveDateSelect)
      this.teamExamList[this.teamExamItemIndex].reserveTime = value;
      console.log("date value reserveDate:", this.teamExamList[this.teamExamItemIndex])
    },

    viewDetail(packageCode){
      this.$API
        .getMedicalExamDetail({
          hospitalCode: this.hospitalCode,
          packageCode: packageCode,
          type: 'G'    // 类型 个人：I，团体：G
        })
        .then(res => {
          this.medicalExamDetail = res.data;
          let dataList=res.data.typeList;
          let itemList=[];
          for(let i=0;i<dataList.length;i++){
            for(let j=0;j<dataList[i].itemList.length;j++){
              itemList.push(dataList[i].itemList[j])
            }
          }
          this.$set(this, "medicalExamDetailData", itemList);
          console.log("medicalExamDetailData:",this.medicalExamDetailData);
          this.titleDetail = res.data.packageName;
          this.activeBox = 3;
        });
      console.log("in viewDetail:", this.activeBox)
      this.activeBox = 3;
    },

    checkBoxChange(value){
      console.log("checkChange:", value);
      console.log("checkValue:", this.checkValue);
    },

    viewAgreement(){
      this.authVisible = true;
    },

    goBackExamInfo(){
      this.activeBox = 2;
    },
    goBackEnter(){
      this.activeBox = 1;
    }
  }
}
</script>

<style lang="less" scoped>
  .teamExam {
    width: 100%;
    height: 100%;
    &.screen-teamExam{
      margin:0 -0.25rem;
      width:calc(100% + 0.5rem)
    }
  }
  .teamExamEnter {
    position: relative;
    width: 100%;
    // height: 100%;
    min-height: 786px;
    background-image: url("../images/teamExamBackground.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
  }
  .enterBox {
    position: absolute;
    top: 15%;
    left: 25%;
    width: 50%;
    padding: 3% 10%;
    background: white;
  }
  .enterTitle {
    font-size: 30px;
    color: #333333;
    letter-spacing: 0.53px;
    text-align: center;
    line-height: 26px;
    font-weight: 700;
    margin-bottom: 40px;
  }
  .itemName {
    text-align: center;
    font-size: 16px;
    color: #333333;
    text-align: center;
    line-height: 16px;
    font-weight: 700;
    margin-bottom: 10px;
  }
  .personSelect {
    width: 100%;
    margin-bottom: 15px;
  }
  .idInput {
    width: 100%;
    margin-bottom: 30px;
  }
  .submitButton {
    width: 100%;
    margin-bottom: 20px;
    border-radius: 23.5px;
  }
  .tips {
    text-align: center;
    font-size: 14px;
    color: #AAAAAA;
    text-align: center;
    line-height: 28px;
    font-weight: 400;
  }

  .teamExamInfo {
    background: #f5f5f5;
    padding-bottom: 80px;
  }
  
  .teamExamInfoTitle {
    padding-top: 80px;
    margin-bottom: 30px;
    text-align: center;
    font-size: 30px;
    color: #333333;
    font-weight: 700;
  }
  .teamExamInfoBox {
    background: white;
    padding: 20px 30px;
  }

  .teamExamSubTitle {
    display: flex;
    margin-bottom: 20px;
    i {
      margin-top: 5px;
      background-image: linear-gradient(180deg, #31a4e0 0%, #166bbd 100%);
      width: 3px;
      height: 0.2rem;
      margin-right: 0.07rem;
    }
    p {
      font-size: 16px;
      color: #333333;
      font-weight: 500;
    }
  }

  .teamExamListItem {
    display: flex;
  }

  .teamExamListItemLeft {
    width: 40px;
    margin-right: 20px;
  }
  .teamExamListItemRight {
    width: 100%;
  }
  .teamExamItemTitle {
    margin-bottom: 10px;
    font-size: 15px;
    color: #333333;
    letter-spacing: 0;
    line-height: 15px;
    font-weight: 600;
  }
  .companyName {
    margin-bottom: 10px;
    padding-bottom: 10px;
    font-size: 13px;
    color: #999999;
    letter-spacing: 0;
    line-height: 13px;
    font-weight: 400;
    border-bottom: 1px solid #f3f3f3;
  }
  .teamExamItemRow {
    display: flex;
    justify-content: space-between;
    padding-bottom: 16px;
  }
  .teamExamItemRowRight {
    font-size: 12px;
    color: #4AAAE9;
    text-align: right;
    line-height: 12px;
    font-weight: 400;
  }

  .personInfoRow {
    display: flex;
    margin-bottom: 20px;
  }
  .personInfoRowLeft {
    width: 25%;
  }

  .authLine {
    display: flex;
    margin-bottom: 80px;
  }
  .checkBoxContent {
    font-size: 14px;
    color: #333333;
    letter-spacing: -0.09px;
    text-align: justify;
    line-height: 14px;
    font-weight: 500;
  }
  .agreement {
    font-size: 14px;
    color: #F39C12;
    letter-spacing: -0.09px;
    text-align: justify;
    line-height: 14px;
    font-weight: 500;
  }

  .submitLine {
    text-align: center;
    padding-bottom: 50px;
  }
  .submitButtonTwo {
    width: 300px;
    margin: auto;
    border-radius: 23.5px;
  }

  .teamExamDetailInfoBox {
    display: flex;
    padding: 10px;
    margin-bottom: 60px;
    background: #f5f5f5;
  }
  .teamExamDetailInfoBoxLeft {
    width: 35%;
    margin-right: 30px;
  }
  .teamExamDetailInfoBoxRight {
    padding-top: 35px;
  }
  .detailInfoTitle {
    font-size: 24px;
    color: #333333;
    text-align: justify;
    line-height: 24px;
    font-weight: 700;
    margin-bottom: 15px;
  }
  .detailInfoFee {
    font-size: 18px;
    color: #F1700F;
    text-align: justify;
    line-height: 18px;
    font-weight: 500;
    margin-bottom: 25px;
  }
  .detailInfoSex {
    font-size: 15px;
    color: #6E6E6E;
    line-height: 15px;
    font-weight: 400;
  }
  .teamExamInfoTab {
    margin-bottom: 50px;
  }

  .mobileTable {
    padding-top: 0.4rem;
    .tableData {
      margin-bottom: 0.2rem;
      .item {
        border-top: 1px solid #ddd;
        display: flex;
        justify-content: center;
        font-size: 0.28rem;
        padding: 0.2rem 0;
        .left {
          width: 20%;
          text-align: right;
        }
        .right {
          width: 80%;

          padding-left: 0.1rem;
        }
      }
      .item:last-child {
        border-bottom: 1px solid #ddd;
      }
    }
    .more {
      padding: 0.4rem 0;
      display: flex;
      justify-content: center;
      .btn {
        font-size: 0.28rem;
        display: inline-block;
        vertical-align: top;
        border: 1px solid;
        border-radius: 1rem;
        padding: 0.1rem 0.3rem;
      }
    }
  }

  .tablebox {
    margin-top: 42px;
    /deep/.ant-table-thead > tr:first-child > th {
      background: #0078d4;
      font-size: 16px;
      height: 56px;
      text-align: center;
      color: #fff;
      font-weight: 100;
      border-left: 2px solid #fff;
    }
    /deep/.ant-table-tbody > tr > td {
      text-align: center;
      color: #474747;
      a {
        color: #474747;
      }
    }
  }

  .examTipsArea {
    margin-bottom:25px;
  }
  .examPhone {
    font-size: 14px;
    color: #0078D4;
    text-align: justify;
    line-height: 22px;
    font-weight: 700;
  }

  .success {
    background: #f5f5f5;
    padding-top: 50px;
    padding-bottom: 70px;
  }
  .successBox {
    background: white;
    padding-top: 25px;
    padding-bottom: 20px;
  }
  .successTitleBox {
    border-bottom: 1px solid #DDDDDD;
    margin-bottom: 25px;
  }
  .successTitle {
    text-align: center;
    font-size: 40px;
    color: #4AAAE9;
    letter-spacing: 0;
    line-height: 40px;
    font-weight: 700;
    margin-bottom: 15px;
  }
  .successTips {
    text-align: center;
    font-size: 14px;
    color: #666666;
    font-weight: 400;
  }
  .successDate {
    text-align: center;
    font-size: 12px;
    color: #999999;
    font-weight: 400;
    padding-bottom: 20px;
  }
  .successContentBox {
    padding: 0 20px 60px;
  }
  .contentBox {
    padding-bottom: 25px;
  }
  .contentRow {
    display: flex;
    border-bottom: 1px solid #DDDDDD;
    padding: 8px 0;
  }
  .contentRowLeft {
    width: 20%;
  }


  .m-screen-mobile {
    .teamExamInfo {
      margin-bottom: 20px;
    }

    .teamExamEnter {
      min-height: 550px;
    }

    .enterBox {
      left: 10%;
      width: 80%;
    }

    .enterTitle {
      font-size: 23px;
    }

    .teamExamSubTitle {
      i {
        height: 0.3rem;
      }
    }

    .teamExamInfoTitle {
      padding-top: 20px;
      font-size: 25px;
    }
    
    .teamExamDetailInfoBox {
      margin-bottom: 20px;
    }
    .teamExamDetailInfoBoxLeft {
      img {
        width: 100%;
        height: 100%;
      }
    }
    .teamExamDetailInfoBoxRight {
      margin-top: 0px;
      padding-top: 0px;
    }
    .detailInfoTitle {
      font-size: 18px;
    }
    .detailInfoFee {
      font-size: 16px;
    }

    .teamExamInfoTab {
      padding: 0 10px;
      margin-bottom: 10px;
    }

    .teamExamSubTitle {
      i {
        height: 0.3rem;
      }
    }

    .authLine {
      margin-bottom: 45px;
    }

    .submitLine {
      padding-bottom: 20px;
    }

    .success {
      padding-top: 0px;
      padding-bottom: 0px;
    }

    .successContentBox {
      padding-bottom: 10px;
    }
  }

  .mobileTable {
    padding-top: 0.4rem;
    .tableData {
      margin-bottom: 0.2rem;
      .item {
        border-top: 1px solid #ddd;
        display: flex;
        justify-content: center;
        font-size: 0.28rem;
        padding: 0.2rem 0;
        .left {
          width: 20%;
          text-align: right;
        }
        .right {
          width: 80%;

          padding-left: 0.1rem;
        }
      }
      .item:last-child {
        border-bottom: 1px solid #ddd;
      }
    }
    .more {
      padding: 0.4rem 0;
      display: flex;
      justify-content: center;
      .btn {
        font-size: 0.28rem;
        display: inline-block;
        vertical-align: top;
        border: 1px solid;
        border-radius: 1rem;
        padding: 0.1rem 0.3rem;
      }
    }
  }

</style>